module.exports = __webpack_public_path__ + "assets/a7749bde950ec05670d5fa28fa82a835.svg";